module.exports = __webpack_public_path__ + "static/DSC_9452-61f2c674804b00928780ec572c54d25a.jpg";